import { BrowserRouter } from 'react-router'
import { AuthProvider } from './auth/AuthContext'
import { ErrorBoundary } from './components/ErrorBoundary'
import { I18nProvider } from './i18n'
import { AppRoutes } from './router'

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          {/* PIVOT-137: the one place a render throw anywhere in the route
              tree is caught, so it shows a translated retry screen instead of
              unmounting to a blank page. Inside AuthProvider/I18nProvider —
              neither of those renders routed content, so they can't be the
              thing that throws, and staying inside them means the fallback
              still has a working useI18n(). */}
          <ErrorBoundary>
            <AppRoutes />
          </ErrorBoundary>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  )
}

export default App
